// @ngInject
function confirmationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level, modalSize = 'md', header = 'common.confirm') {

        if(modalSize != 'xs' && modalSize != 'sm' && modalSize != 'md' && modalSize != 'lg')
            modalSize = 'md'

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'confirmationDialogController as vm',
            templateUrl: 'services/dialogs/confirmationDialog/confirmationDialog.tpl.html',
            size: modalSize
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            },
            header: function() {
                return header;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function confirmationDialogController($uibModalInstance, message, level, header, $sce) {
    var vm = this;

    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.header = header;

    vm.closeModal = closeModal;

    function closeModal(isCompleted) {
        $uibModalInstance.close(isCompleted);
    }
}

angular
    .module('services.dialogs.confirmationDialog', [])
    .service('confirmationDialogService', confirmationDialogService)
    .controller('confirmationDialogController', confirmationDialogController);
